import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import WebFontLoader from 'webfontloader';
import vSelect from 'vue-select';
import '@fortawesome/fontawesome-free/css/all.min.css';

import logo from '@/components/logo';
import waves from '@/components/waves';
import blockHeader from '@/components/blocks/block-header';
import blockText from '@/components/blocks/block-text';
import blockTheme from '@/components/blocks/block-theme';
import activityCard from '@/components/cards/activity-card';
import activitiesGallery from '@/components/blocks/activities-gallery';
import activityInfo from '@/components/blocks/activity-info';
import activityLocation from '@/components/blocks/activity-location';
import activityImagery from '@/components/blocks/activity-imagery';
import subsequentActivities from '@/components/subsequent-activities';
import activityMaterials from '@/components/blocks/activity-materials';
import navbar from '@/components/nav/navbar';
import homepageHeader from '@/components/homepage-header';
import providerSlider from '@/components/blocks/provider-slider';
import activityIcons from '@/components/blocks/activity-icons';
import searchResults from '@/components/blocks/search-results';
import registrationForm from '@/components/form/registration-form';
import inforequestForm from '@/components/form/inforequest-form';
import activateUserForm from '@/components/form/activate-user-form';
import activitiesOverview from '@/components/blocks/activities-overview';
import activityDetail from '@/components/blocks/activity-detail';
import clientDashboardLogin from '@/components/clientdashboard/clientdashboard-login';
import clientDashboardProfile from '@/components/clientdashboard/clientdashboard-profile';
import clientDashboardNavigation from '@/components/clientdashboard/clientdashboard-navigation';
import clientDashboardBookings from '@/components/clientdashboard/clientdashboard-bookings';
import clientDashboardActivate from '@/components/clientdashboard/clientdashboard-activate';
import clientDashboardForgotPassword from '@/components/clientdashboard/clientdashboard-forgot-password';
import clientDashboardSetPassword from '@/components/clientdashboard/clientdashboard-set-password';
import clientDashboardRegister from '@/components/clientdashboard/clientdashboard-register';
import clientDashboardMySchools from '@/components/clientdashboard/clientdashboard-my-schools';
import clientDashboardMyAdvisor from '@/components/clientdashboard/clientdashboard-my-advisor';
import clientDashboardLedger from '@/components/clientdashboard/clientdashboard-ledger';
import footerImages from '@/components/nav/footer-images';

import store from '@/store/store';

import '@/scss/main.scss';

import sentry from '@/plugins/sentry';
sentry.init(window.settings.environment, window.settings.sentryDSN);
import router from '@/js/router/router.js';
import VueLazyLoadConfig from '@/plugins/vuelazyload';
import VueLazyload from 'vue-lazyload';
import vuetify from './plugins/vuetify';
import Vuetify from 'vuetify/lib';
import Axios from 'axios';

Vue.use(VueLazyload, VueLazyLoadConfig, Vuetify, { iconFont: 'fa' });

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC4aLqGM0Xp-x9oXGiRWf2gLBnA459dLuo'
    }
});

Vue.prototype.$useWebP = false;

if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, rawPos) {
            const pos = rawPos > 0 ? rawPos | 0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

if (!String.prototype.repeat) {
    String.prototype.repeat = function(count) {
        'use strict';
        if (this == null)
            throw new TypeError("can't convert " + this + ' to object');

        let str = '' + this;
        // To convert string to integer.
        count = +count;
        // Check NaN
        if (count != count) count = 0;

        if (count < 0)
            throw new RangeError('repeat count must be non-negative');

        if (count == Infinity)
            throw new RangeError('repeat count must be less than infinity');

        count = Math.floor(count);
        if (str.length == 0 || count == 0) return '';

        // Ensuring count is a 31-bit integer allows us to heavily optimize the
        // main part. But anyway, most current (August 2014) browsers can't handle
        // strings 1 << 28 chars or longer, so:
        if (str.length * count >= 1 << 28)
            throw new RangeError(
                'repeat count must not overflow maximum string size'
            );

        const maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while (count) {
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    };
}

Vue.prototype.$useWebP = function() {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
        const testString = !(window.mozInnerScreenX == null) ? 'png' : 'webp';
        // was able or not to get WebP representation
        const result =
            elem.toDataURL('image/webp').indexOf('data:image/' + testString) ==
            0;
        return result;
    }
};

Vue.component('v-selector', vSelect);

window.app = new Vue({
    el: '#app',
    router,
    vuetify,
    store,

    components: {
        logo,
        waves,
        blockHeader,
        blockText,
        blockTheme,
        activityCard,
        activitiesGallery,
        activityInfo,
        activityLocation,
        activityImagery,
        activityIcons,
        subsequentActivities,
        activityMaterials,
        footerImages,
        navbar,
        homepageHeader,
        providerSlider,
        searchResults,
        registrationForm,
        inforequestForm,
        activateUserForm,
        activitiesOverview,
        activityDetail,
        clientDashboardLogin,
        clientDashboardProfile,
        clientDashboardNavigation,
        clientDashboardBookings,
        clientDashboardActivate,
        clientDashboardForgotPassword,
        clientDashboardSetPassword,
        clientDashboardRegister,
        clientDashboardMySchools,
        clientDashboardMyAdvisor,
        clientDashboardLedger
    },

    data: function() {
        return {
            documentTypeAlias: '',
            activity_search: {
                pageCount: 0,
                selectedFilters: '',
                currentPage: 0,
                searchTerm: '',
                firstLoad: 0,
                selectedView: 'view--list'
            }
        };
    },

    beforeMount: function() {
        const excludeActivities = [
            'uBookingsActivityDetail',
            'uBookingsActivityOverview'
        ];

        this.documentTypeAlias = this.$el.attributes[
            'data-document-type-alias'
        ].value;

        if (excludeActivities.indexOf(this.documentTypeAlias) < 0) {
            sessionStorage.setItem(
                'activity-overview',
                JSON.stringify(this.activity_search)
            );
        }
    },

    created() {
        WebFontLoader.load({
            google: {
                families: ['Fredoka One']
            }
        });

        if (JSON.parse(sessionStorage.getItem('activity-overview')) === null) {
            sessionStorage.setItem(
                'activity-overview',
                JSON.stringify(this.activity_search)
            );
        }
        Axios.get('/api/clientdashboard/account/profile')
            .then(response => {
                this.$store.commit('setUser', response.data.user);
            })
            .catch(() => false);
    }
});
